<template>
<div id="removeclass">
   <app-modal
    :modal-id="modalId"
    modal-alignment="top"
    modal-size="fullscreen"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title">{{ $t("bid_form") }}</h5>
      <!-- <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        @click="closeModal"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button> -->
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        {{ $t("close") }}
      </button>
    </template>
    <template slot="body">
      <div class="row">
        <div class="col-sm-12">
          <form-preview :id="form_body_id"></form-preview>
        </div>
      </div>
    </template>

    <!-- <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        {{ $t("close") }}
      </button>
    </template> -->
  </app-modal>
</div>
 
</template>

<script>
import { ModalMixin } from "../../../../../../app/Mixins/ModalMixin";
export default {
  name: "BidFormViewModal",
  mixins: [ModalMixin],
  props: {
    form_body_id: Number,
  },
  data() {
    return {
      modalId: "bid-form-view-Modal",
    };
  },
};
</script>
